export const DATE_FORMAT_MDY = 'MM/DD/YYYY';
export const DAYS = 'days';
export const DEFAULT_DAYS = 15 * 24 * 60 * 60 * 1000;
export const INPUT_FORMAT = 'dd/MM/yyyy';
export const INPUT_MASK = '__/__/____';
